import { IBaseEntity } from './base-entity'

export enum MainComponentEventCategory {
  Unknown = 0,
  Note = 1,
  Inspection = 2,
  Repair = 3,
  Service = 4,
  Incident = 5,
  Other = 6,
}

export interface IMainComponentEvent extends IBaseEntity {
  title: string
  description?: string
  category: MainComponentEventCategory
  effectiveDate?: string
  mainComponentId: number
}
